<form [formGroup]="chequeRemittanceForm" (ngSubmit)="onSubmit()" [hasUnsavedData]="chequeRemittanceForm">
  <button type="submit" hidden="hidden"></button>
  <div class="row">

    <div class="col-6 col-lg-6">
      <div class="form-group row">
        <label class="col-4 col-form-label-sm" for="salesTeamAccountId" translate>CHEQUE_REMITTANCE_LBL_SALES_TEAM_ACCOUNT</label>
        <div class="col">
          <app-typeahead
            id="salesTeamAccountId"
            [routeEndpoint]="'Accounts'"
            [controlForm]="this.chequeRemittanceForm.get('salesTeamAccountId')"
            [domain]="'accountType=2,active=1'"
            [orderBy]="'name asc'"
            [limitToList]="true"
          />
        </div>
      </div>

      <div class="form-group row">
        <label class="col-4 col-form-label-sm" for="bankAccountId" translate>CHEQUE_REMITTANCE_LBL_BANK_ACCOUNT</label>
        <div class="col">
          <app-typeahead
            id="bankAccountId"
            [routeEndpoint]="'BankAccounts'"
            [controlForm]="this.chequeRemittanceForm.get('bankAccountId')"
            [orderBy]="'iban asc'"
            [limitToList]="true"
            [domain]="this.bankAccountDomain"
            [dbNameOfName]="'iban'"
          />
        </div>
      </div>

      <div class="form-group row">
        <label class="col-4 col-form-label-sm" for="deliveryDate" translate
        >CHEQUE_REMITTANCE_LBL_DELIVERY_DATE</label
        >
        <div class="col">
          <input
            id="deliveryDate"
            class="form-control form-control-sm"
            type="date"
            [max]="this.maxDateMaskSafeGuard"
            formControlName="deliveryDate"
            checkFormFieldValidity
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="form-group row">
        <label class="col-4 col-form-label-sm" translate>CHEQUE_REMITTANCE_LBL_CHEQUES_COUNT</label>
        <div class="col">
          <span class="form-control-plaintext form-control-sm">
            {{ this.paymentEntryModelsCount }}
          </span>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-4 col-form-label-sm" translate>CHEQUE_REMITTANCE_LBL_TOTAL_AMOUNT</label>
        <div class="col">
          <span class="form-control-plaintext form-control-sm">
            {{ this.paymentEntryModelsTotalAmount | currency : 'EUR'}}
          </span>
        </div>
      </div>

    </div>

    <div class="row mt-2">
      <div class="col">
        <div class="d-flex justify-content-between align-items-center">
          <div class="form-group-title my-1" translate>
            CHEQUE_REMITTANCE_FIELDSET_CHEQUES
          </div>
          <div class="text-end ms-auto">
            <button
              type="button"
              class="btn-sm btn btn-primary mb-2"
              (click)="openModalChoiceAccountMovesCheques()"
              translate
            >
              CHEQUE_REMITTANCE_BTN_ADD_REMOVE
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col">
        <table class="table table-striped border-bottom">
          <thead>


          <tr>
            <th>
              <a translate>CHEQUE_REMITTANCE_LBL_CLIENT</a>
            </th>
            <th>
              <a translate>CHEQUE_REMITTANCE_LBL_DATE</a>
            </th>
            <th>
              <a translate>CHEQUE_REMITTANCE_LBL_REFERENCE</a>
            </th>
            <th>
              <a translate>CHEQUE_REMITTANCE_LBL_AMOUNT</a>
            </th>
<!--            <th>-->
<!--              <a translate>CHEQUE_REMITTANCE_LBL_STATUS</a>-->
<!--            </th>-->
          </tr>

          </thead>

          <tbody>
            @if (this.paymentEntryModels) {

                <ng-container class="row-action">
                  @for (paymentEntryModel of this.paymentEntryModels; track paymentEntryModel.accountMoveId) {

                    <tr>
                      <td>
                        {{ paymentEntryModel.accountMoveDebitAccountName }}
                      </td>
                      <td>
                        {{ paymentEntryModel.creationDate | toLocalTime : "dd/MM/yyyy" }}
                      </td>
                      <td>{{ paymentEntryModel.accountMoveReference }}</td>
                      <td>{{ paymentEntryModel.amount | currency : "EUR" }}</td>
<!--                      <td>{{ paymentEntryModel.accountMoveStatusLoc }}</td>-->
                    </tr>
                  }
                </ng-container>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</form>
